<template>
  <div>
    <Breadcrumbs main="Users" title="Edit employee profile" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">

          <div class="col-xl-12">
            <div>
              <div class="container-fluid">
                <div class="loader-box" v-if="isLoading">
                  <div class="loader-20"></div>
                </div>
                <div class="row" v-if="getUser">
                  <div class="col-sm-12">
                    <div class="card">
                      <div class="card-header">
                        <h5>Employee Details</h5>
                        <b-row align-h="end">
                            <b-dropdown text="Print zone" menu-class="dropdown-content" variant="primary">
                            <b-dropdown-header id="dropdown-header-label">
                                Agreements
                            </b-dropdown-header>
                            <b-dropdown-item @click="renderDoc('contract')">Employee contract</b-dropdown-item>
                            <b-dropdown-item @click="renderDoc('regulations')">Work regulations</b-dropdown-item>
                            <b-dropdown-item @click="renderDoc('cooperation')">Terms of cooperation</b-dropdown-item>
                            <b-dropdown-item @click="renderDoc('rental')">Rental agreement</b-dropdown-item>

                        </b-dropdown>
                          <b-button
                            v-if="isAdmin"
                            align-h="end"
                            type="button"
                            @click="deleteUser"
                            class="btn-danger"
                            >Delete</b-button
                          >
                          </b-row
                        >
                      </div>
                      <form class="form theme-form" @submit.prevent>
                        <div class="card-body">
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label>First name</label>
                                <b-form-input
                                  type="text"
                                  placeholder="Jan"
                                  v-model="getUser.firstName"
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label>Last name</label>
                                <b-form-input
                                  type="text"
                                  placeholder="Kowalski"
                                  v-model="getUser.lastName"
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>E-mail</label>
                                <b-form-input
                                  type="email"
                                  placeholder="Kowalski"
                                  v-model="getUser.mail"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Phone number</label>
                                <b-form-input
                                  type="tel"
                                  placeholder="555-666-222"
                                  v-model="getUser.phoneNum"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Work start</label>
                                <b-form-input
                                  type="date"
                                  placeholder="Kowalski"
                                  v-model="getUser.workStart"
                                  required
                                ></b-form-input>
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Zip code</label>
                                <b-form-input
                                  type="text"
                                  v-model="getUser.zip"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Street</label>
                                <b-form-input
                                  type="text"
                                  v-model="getUser.street"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>City</label>
                                <b-form-input
                                  type="text"
                                  v-model="getUser.city"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Driving number license</label>
                                <b-form-input
                                  type="text"
                                  v-model="getUser.drivingLicense"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Identification document number</label>
                                <b-form-input
                                  type="text"
                                  v-model="getUser.identificationNum"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Contract date</label>
                                <b-form-input
                                  type="date"
                                  v-model="getUser.dateContract"
                                  required
                                ></b-form-input>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Driving system</label>
                                <b-form-select
                                  placeholder="Kowalski"
                                  v-model="getUser.drivingSys"
                                  :options="options"
                                ></b-form-select>
                              </div>
                            </div>
                          </div>
                          <div class="media">
                            <label class="col-form-label m-r-10">Active</label>
                            <div class="media-body text-right">
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="getUser.active"
                                /><span class="switch-state"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <b-button
                            type="button"
                            @click.prevent="addEmployee"
                            variant="primary"
                            class="mr-1"
                            >Update</b-button
                          >
                          <b-button type="reset" variant="light"
                            >Cancel</b-button
                          >
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="container-fluid">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title mb-0">
                    {{
                      getUserShifts
                        ? "Employee shifts"
                        : "User have not any shifts, let him ride!"
                    }}
                  </h4>
                  <div class="card-options">
                    <a
                      class="card-options-collapse"
                      href="#"
                      data-toggle="card-collapse"
                      ><i class="fe fe-chevron-up"></i></a
                    ><a
                      class="card-options-remove"
                      href="#"
                      data-toggle="card-remove"
                      ><i class="fe fe-x"></i
                    ></a>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <table class="table card-table table-vcenter text-nowrap">
                    <thead>
                      <tr>
                        <th>Car</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Earning</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-if="getUserShifts">
                      <tr v-for="shift in getUserShifts" :key="shift.id">
                        <td>
                          <a class="text-inherit">{{ shift.regPlate }} </a>
                        </td>
                        <td>{{ shift.date }}</td>
                        <td>
                          <span class="status-icon bg-success"></span>
                          {{ shift.active ? "Active" : "Not active" }}
                        </td>
                        <td>
                          {{
                            shift.active
                              ? "Driving.."
                              : shift.money + shift.earning
                          }}
                        </td>
                        <td class="text-right">
                          <a class="icon" href="javascript:void(0)"></a
                          ><a
                            class="btn btn-primary btn-sm"
                            href="javascript:void(0)"
                            ><i class="fa fa-pencil"></i> Details</a
                          ><a class="icon" href="javascript:void(0)"></a
                          ><a class="icon" href="javascript:void(0)"></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="container-fluid">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title mb-0">
                    {{
                      getUserShifts
                        ? "Employee salary"
                        : "User have not any shifts, let him ride!"
                    }}
                  </h4>
                </div>
                <div class="card-body">
                  Users didn't submit salary.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}
export default {
  data() {
    return {
      selected: null,
      formStatus: null,
      options: [
        { value: null, text: "Please select driving system" },
        { value: "3Z", text: "3 shifts system" },
        { value: "2Z", text: "2 shifts system" },
        { value: "SOLO", text: "Solo shift system" },
      ],
      formData: {
        firstName: null,
        lastName: null,
        mail: null,
        phoneNum: null,
        workStart: null,
        drivingSys: null,
        active: null,
      },
      isLoading: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async addEmployee() {
      try {
        await this.$store.dispatch("users/updateEmployee", {
          data: {
            firstName: this.getUser.firstName,
            lastName: this.getUser.lastName,
            mail: this.getUser.mail,
            phoneNum: this.getUser.phoneNum,
            workStart: this.getUser.workStart,
            drivingSys: this.getUser.drivingSys,
            active: this.getUser.active,
            drivingLicense: this.getUser.drivingLicense,
            street: this.getUser.street,
            identificationNum: this.getUser.identificationNum,
            city: this.getUser.city,
            zip: this.getUser.zip,
            dateContract: this.getUser.dateContract
          },
          param: this.$route.params.id,
        });
      } catch (error) {
        this.formStatus = true;
        this.basic_success_alert(
          "Something went wrong",
          "There is a problem with updating employee data - please try again later"
        );
      }
      if (!this.formStatus) {
        this.basic_success_alert("Employee updated!", "Operation done.");
      }
    },
    basic_success_alert: function(title, text) {
      this.$swal({
        title: title,
        text: text,
        type: "info",
      });
    },
    async fetchData() {
      this.isLoading = true;
      await this.$store.dispatch("users/fetchSingle", this.$route.params.id);
      await this.$store.dispatch("shifts/fetchShifts");
      this.isLoading = false;
    },
    async deleteUser() {
      await this.$swal({
        text: "Are you sure you want to do this?",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        confirmButtonColor: "#4466f2",
        cancelButtonText: "Bring me back!",
        cancelButtonColor: "#efefef",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("users/deleteUser", this.$route.params.id);
          this.$router.push("/employees/manage");
        } else if (result.dismiss) {
          console.log("dissmised");
        }
      });
    },
    renderDoc(mode) {
      let url = null
      if(mode === 'contract'){
        url = 'https://api.rightcloud.pl/uploads/umowa_zlecenie_428eafa55c.docx'
      }
      if(mode === 'cooperation'){
        url = 'https://api.rightcloud.pl/uploads/terms_cooperation_bee3d9e173.docx'
      }
      if(mode === 'rental'){
        url = 'https://api.rightcloud.pl/uploads/rentalagreement_5b5c70506f.docx'
      }
      if(mode === 'regulations'){
        url = 'https://api.rightcloud.pl/uploads/REGULAMIN_3_Z_3af17c2253.docx'
      }
      const date = new Date(this.getUser.dateContract)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      const that = this
      loadFile(url, function(
        error,
        content
      ) {
        if (error) {
          throw error;
        }
        var zip = new PizZip(content);
        var doc = new Docxtemplater().loadZip(zip);
        doc.setData({
          firstName: that.getUser.firstName,
          lastName: that.getUser.lastName,
          identificationNum: that.getUser.identificationNum,
          city: that.getUser.city,
          zip: that.getUser.zip,
          street: that.getUser.street,
          dateContract: `${day}.${month}.${year}`
        });
        try {
          doc.render();
        } catch (error) {
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
          function replaceErrors(key, value) {
            if (value instanceof Error) {
              return Object.getOwnPropertyNames(value).reduce(function(
                error,
                key
              ) {
                error[key] = value[key];
                return error;
              },
              {});
            }
            return value;
          }
          console.log(JSON.stringify({ error: error }, replaceErrors));

          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function(error) {
                return error.properties.explanation;
              })
              .join("\n");
            console.log("errorMessages", errorMessages);
            // errorMessages is a humanly readable message looking like this :
            // 'The tag beginning with "foobar" is unopened'
          }
          throw error;
        }
        var out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        }); //Output the document using Data-URI
        if(mode === 'contract'){
        saveAs(out, `uz-${that.getUser.firstName}-${that.getUser.lastName}.docx`);
        }
        if(mode === 'cooperation'){
        saveAs(out, `regulamin-wspolpracy-${that.getUser.firstName}-${that.getUser.lastName}.docx`);
        }
        if(mode === 'rental'){
        saveAs(out, `umowa-najmu-${that.getUser.firstName}-${that.getUser.lastName}.docx`);
        }
        if(mode === 'regulations'){
        saveAs(out, `regulamin3z-${that.getUser.firstName}-${that.getUser.lastName}.docx`);
        }
      });
    },
    printTemplate() {
      this.$swal({
        text: "Do you want to print rental agreement?",
        showCancelButton: true,
        confirmButtonText: "Yes!",
        confirmButtonColor: "#4466f2",
        cancelButtonText: "No",
        cancelButtonColor: "#efefef",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.renderDoc()
        } else if (result.dismiss) {
          console.log("dissmised");
        }
      });
    },
  },

  computed: {
    getError() {
      const response = this.$store.getters["users/getError"];
      if (response.state) {
        return this.basic_success_alert(
          "We are sorry, employee not added",
          response.msg
        );
      }
    },
    isAdmin() {
      return !this.isLoading && this.$store.getters["auth/isAdmin"];
    },
    getUser() {
      return !this.isLoading && this.$store.getters["users/getSingle"];
    },
    getUserShifts() {
      let allShifts = this.$store.getters["shifts/getAllShifts"];
      let shifts = allShifts.filter(
        (item) => item.selectedPassing === this.$route.params.id
      );
      console.log(shifts);
      if (!this.isLoading && shifts.length > 0) {
        return shifts.reverse();
      } else {
        return false;
      }
    },
  },
};
</script>
